// ============================================================================
// BUSINESS UNIT (BRANCH) SERVICE
// ============================================================================

import { get, post, patch, del } from '../client/axiosClient';
import { businessUnitEndpoints } from '../endpoints/businessUnit.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  BusinessUnit,
  CreateBusinessUnitRequest,
  UpdateBusinessUnitRequest,
  BusinessUnitFilterParams,
} from '../types/businessUnit.types';

class BusinessUnitService {
  async getAll(params?: BusinessUnitFilterParams): Promise<PaginatedResponse<BusinessUnit>> {
    const endpoint = params
      ? buildEndpointWithQuery(businessUnitEndpoints.list(), params)
      : businessUnitEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<BusinessUnit>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<BusinessUnit>> {
    const response = await get<ApiResponse<BusinessUnit>>(businessUnitEndpoints.getById(id));
    return response.data;
  }

  async create(payload: CreateBusinessUnitRequest): Promise<ApiResponse<BusinessUnit>> {
    const response = await post<ApiResponse<BusinessUnit>>(businessUnitEndpoints.create(), payload);
    return response.data;
  }

  async update(id: ID, payload: UpdateBusinessUnitRequest): Promise<ApiResponse<BusinessUnit>> {
    const response = await patch<ApiResponse<BusinessUnit>>(businessUnitEndpoints.update(id), payload);
    return response.data;
  }

  async delete(id: ID): Promise<ApiResponse<void>> {
    const response = await del<ApiResponse<void>>(businessUnitEndpoints.delete(id));
    return response.data;
  }
}

export const businessUnitService = new BusinessUnitService();
export default businessUnitService;
